import { createAction } from 'redux-actions';
import { EventOption } from './type';

const actions = {
  /**
   * [기획전] 기획전 데이터 변경하기
   */
  SET_DATA: 'event/SET_DATA',
  setData: createAction('event/SET_DATA'),

  /**
   * [진행중인 기획전] 진행중인 기획전 리스트 요청하기
   */
  GET_IN_PROGRESS_EVENT_LIST_REQUEST: 'event/GET_IN_PROGRESS_EVENT_LIST_REQUEST',
  GET_IN_PROGRESS_EVENT_LIST_SUCCESS: 'event/GET_IN_PROGRESS_EVENT_LIST_SUCCESS',
  getInProgressEventList: createAction<EventOption>('event/GET_IN_PROGRESS_EVENT_LIST_REQUEST'),

  /**
   * [진행중인 기획전] 진행중인 기획전 리스트 엑셀 다운로드 요청하기
   */
  GET_IN_PROGRESS_EVENT_EXCEL_DOWNLOAD_REQUEST: 'event/GET_IN_PROGRESS_EVENT_EXCEL_DOWNLOAD_REQUEST',
  GET_IN_PROGRESS_EVENT_EXCEL_DOWNLOAD_SUCCESS: 'event/GET_IN_PROGRESS_EVENT_EXCEL_DOWNLOAD_SUCCESS',
  getInProgressEventExcelDownload: createAction('event/GET_IN_PROGRESS_EVENT_EXCEL_DOWNLOAD_REQUEST'),

  /**
   * [전체 기획전] 전체 기획전 리스트 요청하기
   */
  GET_ALL_EVENT_LIST_REQUEST: 'event/GET_ALL_EVENT_LIST_REQUEST',
  GET_ALL_EVENT_LIST_SUCCESS: 'event/GET_ALL_EVENT_LIST_SUCCESS',
  getAllEventList: createAction<EventOption>('event/GET_ALL_EVENT_LIST_REQUEST'),

  /**
   * [전체 기획전] 전체 기획전 리스트 엑셀 다운로드 요청하기
   */
  GET_ALL_EVENT_EXCEL_DOWNLOAD_REQUEST: 'event/GET_ALL_EVENT_EXCEL_DOWNLOAD_REQUEST',
  GET_ALL_EVENT_EXCEL_DOWNLOAD_SUCCESS: 'event/GET_ALL_EVENT_EXCEL_DOWNLOAD_SUCCESS',
  getAllEventExcelDownload: createAction('event/GET_ALL_EVENT_EXCEL_DOWNLOAD_REQUEST'),

  /**
   *  [진행중인 기획전, 전체 기획전] 태그 리스트 요청하기
   */
  GET_EVENT_TAG_COLUMN_TAG_LIST_REQUEST: 'event/GET_EVENT_TAG_COLUMN_TAG_LIST_REQUEST',
  getEventTagColumnTagList: createAction('event/GET_EVENT_TAG_COLUMN_TAG_LIST_REQUEST'),

  /**
   * [기획전 등록] 선택된 기획전 상품 excel 리스트 다운로드
   */
  GET_SELECTED_EVENT_PRODUCT_EXCEL_DOWNLOAD_REQUEST: 'event/GET_SELECTED_EVENT_PRODUCT_EXCEL_DOWNLOAD_REQUEST',
  GET_SELECTED_EVENT_PRODUCT_EXCEL_DOWNLOAD_SUCCESS: 'event/GET_SELECTED_EVENT_PRODUCT_EXCEL_DOWNLOAD_SUCCESS',
  getSelectedEventItemExcelDownload: createAction('event/GET_SELECTED_EVENT_PRODUCT_EXCEL_DOWNLOAD_REQUEST'),

  /**
   *  [기획전 등록,편집] 선택 태그 리스트 엑셀 다운로드
   */
  GET_EVENT_TAG_SELECTED_LIST_EXCEL_DOWNLOAD_REQUEST: 'event/GET_EVENT_TAG_SELECTED_LIST_EXCEL_DOWNLOAD_REQUEST',
  getEventTagSelectedListExcelDownload: createAction('event/GET_EVENT_TAG_SELECTED_LIST_EXCEL_DOWNLOAD_REQUEST'),

  /**
   * 모달 토글
   */
  TOGGLE_MODAL: 'event/TOGGLE_MODAL',
  toggleModal: createAction('event/TOGGLE_MODAL'),
};

export default actions;
